module.exports = __webpack_public_path__ + "static/media/21-min.jpg.2163137b.webp";